export class TokenNotFoundException extends Error {
  constructor(error: string) {
    super(error);
    this.name = 'TokenNotFoundException';
  }
}
